import React, { useRef, useState, useEffect } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IItemDetail } from "../itemType";
import { getFormValidatorErrText } from "@/utils/utils"
import { useItemModel } from "../itemModel";
import { useDictModel } from "../../dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export const BaseItemDetails = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeSelectOne, getSelectedDictOne } = useDictModel();
    const {
        addFormVal,
        editFormVal,
        updateAddFormVal,
        updateEditFormVal,
        insertDetail,
        editDetail,
        getDetailOne,
        setAddFormVal,
        setSelectedRowKeys

    } = useItemModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const formRef = useRef<IYhFormRef>();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    //编辑时， 没有缓在调用详情接口
    useEffect(() => {
        if (!Object.keys(editFormVal).length && detailsInfo.mode === "edit") {
            getDetailOne(detailsInfo.id)
        }
    }, [detailsInfo]);

    useEffect(() => {
        return () => {
            let addNavExist = findNav("13-6-1");
            let editNavExist = findNav("13-6-2");
            !addNavExist && updateAddFormVal({});
            !editNavExist && updateEditFormVal({});
        }
    }, [])

    //关闭当前页
    const onClose = () => {
        replaceNav(selectedNavId, "13-6");
        detailsInfo.mode === "edit" ? updateEditFormVal({}) : updateAddFormVal({});
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            if (detailsInfo.mode === "edit") {
                editDetail({ ...res, id: detailsInfo.id } as IItemDetail).then(res => {
                    res && onClose()
                })
            } else {
                insertDetail(res as IItemDetail).then(res => {
                    if(res){
                        setSelectedRowKeys([res])
                        onClose()
                    }
                })
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //实时保留缓存
    const onChange = (changedValues: { [key: string]: any }) => {
        detailsInfo.mode === "edit" ? updateEditFormVal(changedValues) : updateAddFormVal(changedValues);
    }

    const baseFormItem: IYhFormItemsBox = {
        // title: "基础信息",
        title: Locale["Basic Info"],
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "项目编号",
                fieldLabel: Locale["Item Code"],
                fieldName: "code",
                // rules: [{ required: true, message: "请输入项目编号" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "项目名称",
                fieldLabel: Locale["Item"],
                fieldName: "name",
                // rules: [{ required: true, message: "请输入项目名称" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "项目名称",
                fieldLabel: Locale["ItemEn"],
                fieldName: "nameEn",
                // rules: [{ required: true, message: "请输入项目名称" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]                
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "工时",
                fieldLabel: Locale["Man-hours"],
                fieldName: "workHours",
                // rules: [{ required: true, message: "请输入工时" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "单价",
                fieldLabel: Locale["Unit Price"],
                fieldName: "price",
                // rules: [{ required: true, message: "请输入单价" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]

            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "工时费",
                fieldLabel: Locale["Labor Cost"],
                fieldName: "amount",
                disable: true,
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "维修类型",
                fieldLabel: Locale["Service Type"],
                fieldName: "typeCode",
                options: getSelectedDictOne(DictCodeEnmu.REPAIR_TYPE)
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note"
            }, {
                type: FormItemTypeEnum.Switch,
                // fieldLabel: "状态",
                fieldLabel: Locale["Status"],
                fieldName: "enable",
            }
        ]
    };


    const supplierFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: detailsInfo.mode === "edit" ? editFormVal : addFormVal,
        onChange,
        boxs: [baseFormItem]
    }

    const reset = async () => {
        formRef.current?.resetFields()
        if (detailsInfo.mode === "add") {
            setAddFormVal({})
        } else if (detailsInfo.mode === "edit") {
            getDetailOne(detailsInfo.id)
        }
        message.success("重置成功")
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onSubmit}
        >{Locale["Save"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => reset()}
        >{Locale["Reset"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onClose}
        >{Locale["Back"]}</Button>
    </>;

    return (
        <>
            <YhPageHeader title={Locale["Item Details"]} />
            <YhBox title={`${detailsInfo.mode === "edit" ? Locale["Edit Maintenance Item"] : Locale["New Maintenance Item"]}`} action={action} style={{ paddingBottom: "0px", marginBottom: "15px" }}></YhBox>
            <YhFormBox {...supplierFromConfig} />
        </>
    )
}